import _ from 'lodash';

import { ACTION_PLAN_STEP_EXPANSION_KEY } from 'constants/aiChat';

export const initialActionPlanExpansionsState = {};

export const applySetActionPlanExpansion = (state, payload) => {
  const { executionId, stepKey, contentId = null, expanded } = payload ?? {};

  if (_.isNil(executionId) || _.isNil(stepKey)) {
    return state;
  }

  const executionEntry = state[executionId] ?? {};
  const stepEntry = executionEntry[stepKey] ?? {};
  const targetKey = contentId ?? ACTION_PLAN_STEP_EXPANSION_KEY;

  return {
    ...state,
    [executionId]: {
      ...executionEntry,
      [stepKey]: {
        ...stepEntry,
        [targetKey]: !!expanded,
      },
    },
  };
};
